import { API } from "aws-amplify";
import { useQuery } from "react-query";
import { IGeneialSchemaVersion } from "../../../../routes/registries/models/GeneialSchemaVersion";
import { APIEndpoints, QueryKeys } from "../../config";

const makeApiRequest = (): Promise<IGeneialSchemaVersion[]> => {
  const qParams = {};

  return API.get(APIEndpoints.private, `/api/v1/schemas/versions/`, qParams);
};

export const useListSchemaVersions = () => {
  return useQuery<IGeneialSchemaVersion[]>(
    QueryKeys.schemaVersions(),
    () => makeApiRequest(),
    {
      retry: 1,
      select: (data: IGeneialSchemaVersion[]) => {
        data.sort((a, b) => {
          const aVersion = `${a.schema_title} ${a.version_major}${a.version_minor}${a.version_patch}`;
          const bVersion = `${b.schema_title} ${b.version_major}${b.version_minor}${b.version_patch}`;

          if (aVersion < bVersion) {
            return -1;
          }
          if (aVersion > bVersion) {
            return 1;
          }
          return 0;
        });

        return data;
      },
    }
  );
};
